export const RESET_PASSWORD_FLOW_PARAM = 'flow';
export const RESET_PASSWORD_FLOW = 'reset-password';

const LOGIN_PATHS = ['/', '/v2'];
const MAX_EMAIL_LENGTH = 254;

declare global {
  interface Window {
    // Captured by public/index.html before GTM; consumed once at app startup.
    __cwResetPasswordEmailHint?: string;
  }
}

export const hasResetPasswordFlow = (params: URLSearchParams): boolean =>
  params.get(RESET_PASSWORD_FLOW_PARAM) === RESET_PASSWORD_FLOW;

export const isPasswordResetEntry = (
  location: Pick<Location, 'pathname' | 'search'>
): boolean => {
  if (!LOGIN_PATHS.includes(location.pathname)) return false;

  const params = new URLSearchParams(location.search);
  return hasResetPasswordFlow(params) || params.get('message') === 'invalid-reset-link';
};

/** Consume the untrusted prefill before React or URL-based telemetry starts. */
export const consumeResetPasswordEmailHint = (): string | undefined => {
  const hint = window.__cwResetPasswordEmailHint;
  delete window.__cwResetPasswordEmailHint;

  if (
    !LOGIN_PATHS.includes(window.location.pathname) ||
    !hasResetPasswordFlow(new URLSearchParams(window.location.search))
  ) {
    return undefined;
  }

  const email = hint?.trim();
  if (!email || email.length > MAX_EMAIL_LENGTH) return undefined;

  const input = document.createElement('input');
  input.type = 'email';
  input.value = email;
  const domain = email.slice(email.lastIndexOf('@') + 1);

  return input.value === email && !input.validity.typeMismatch && domain.includes('.')
    ? email
    : undefined;
};
